import React from 'react';
import { connect, useSelector } from 'react-redux';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

class About extends React.Component{    
	constructor( props ){
		super(props);
	}

    render(){
        return (
                <div className="standard-content-container about-page">
					<MetaTags>
						<title>About | Tom Rice Portfolio 2025</title>
						<meta id="meta-description" name="description" content="About me" />
						<meta id="og-title" property="og:title" content="About | Tom Rice Portfolio 2025" />
					</MetaTags>
					
					<p>A web developer since 2017 and a graduate with a 2:1 in Mathematics from the University of Portsmouth, often coding to aide in my studies. You can see me on LinkedIn by <a href="https://www.linkedin.com/in/tom-rice-154840151/" target="_blank">clicking here</a>.</p>
					<p>This site is currently a work in progress. If you see any errors, do let me know!</p>
					<p>To do:</p>
					<ul>
						<li>User system / CMS</li>
						<li>More themes!</li>
						<li>Modify to be able to support multiple projects</li>
						<li>Sort and filter functionality</li>
						<li>Border changes on content boxes</li>
						<li>Review for anything missing</li>
						<li><s>Update text for 2025</s></li>
						<li>Remove any broken links (sorry!)</li>
						<li>Favicon on media</li>
					</ul>
                </div>
        );
    }
}

export default About;